import axios from 'axios';

// The repo allows the env variables to be set with the full path the user provided
// REACT_APP_BASE_TST: https://tst-clubgas-api.azurewebsites.net/api/v1/
// REACT_APP_BASE_PRD: https://clubgas-api.azurewebsites.net/api/v1/
// REACT_APP_USE_BASE: 'tst' or 'prd' (defaults to 'tst')
// const rawBaseTst = process.env.REACT_APP_BASE_TST;
// const rawBasePrd = process.env.REACT_APP_BASE_PRD;
// // const useBase = (process.env.REACT_APP_USE_BASE || 'tst').toLowerCase();

// function normalizeEnvBase(raw?: string): string | undefined {
//   if (!raw) return undefined;
//   // If user provided a base that already includes '/api/v1' strip that segment so
//   // existing calls that include '/api/v1/...' don't end up with duplicated paths.
//   return raw.replace(/\/api\/v1\/?$/i, '').replace(/\/$/, '') + '/';
// }

// const baseTst =
//   normalizeEnvBase(rawBaseTst) || 'https://tst-clubgas-api.azurewebsites.net/';
// const basePrd =
//   normalizeEnvBase(rawBasePrd) || 'https://clubgas-api.azurewebsites.net/';

const baseURL = 'https://clubgas-api.azurewebsites.net/';

export const API = axios.create({ baseURL });
